/*
 * Mobile back-button closes the slide-out cart drawer instead of leaving the site.
 *
 * The cart drawer is a native <dialog> that opens WITHOUT adding a history entry, so on
 * mobile the Back button / edge-swipe navigates the page (and exits the site when the
 * drawer was opened on the landing page). Fix: push a throwaway history entry when the
 * drawer opens; a Back press then pops that entry and we close the drawer. Closing the
 * drawer any other way (X, Esc, backdrop, Checkout) consumes the entry so history stays tidy.
 */
(function () {
  var pushedFor = null; // the dialog we pushed a history entry for, or null

  function hook(dlg) {
    if (!dlg || dlg.__dgtBackClose) return;
    dlg.__dgtBackClose = true;

    // Watch the native `open` attribute to detect open (no native "open" event exists).
    new MutationObserver(function () {
      if (dlg.open && pushedFor !== dlg) {
        try { history.pushState({ dgtCartDrawer: true }, ''); } catch (e) {}
        pushedFor = dlg;
      }
    }).observe(dlg, { attributes: true, attributeFilter: ['open'] });

    // Closed by the user (X / Esc / backdrop) — remove our throwaway entry.
    dlg.addEventListener('close', function () {
      if (pushedFor === dlg) {
        pushedFor = null;
        if (history.state && history.state.dgtCartDrawer) {
          try { history.back(); } catch (e) {}
        }
      }
    });
  }

  // Back pressed while the drawer is open: the entry is already popped, so just close.
  window.addEventListener('popstate', function () {
    if (pushedFor && pushedFor.open) {
      var dlg = pushedFor;
      pushedFor = null; // don't call history.back() again from the close handler
      try { dlg.close(); } catch (e) {}
    }
  });

  function scan() {
    document.querySelectorAll('cart-drawer-component dialog').forEach(hook);
  }
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  // The drawer can be re-rendered; keep watching for a fresh dialog node.
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();
